// extracted by mini-css-extract-plugin
export var icon = "_54-1";
export var subtext = "_54-0";